import AppleIcon from "@/components/icons/AppleIcon";
import OAuthLoginButton from "./OAuthLoginButton";

export default function AppleLoginButton({
  size
}: {
  size?: "md" | "lg";
}) {
  return (
    <>
      {/* Warm up DNS/TLS to Apple's auth server so the redirect after
          click is faster. No crossOrigin: a navigation uses a
          credentialed connection, which must match the preconnect. */}
      <link rel="preconnect" href="https://appleid.apple.com" />
      <OAuthLoginButton
        provider="apple"
        icon={<AppleIcon size={size === "lg" ? 22 : 18} />}
        label="Doorgaan met Apple"
        size={size}
      />
    </>
  );
}
